import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { createRefetchContainer, graphql } from 'react-relay';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useCommonStyles } from '../common/Styles';
import TableFieldMeta from '../../common/TableFieldMeta';
import BaseGridContainer from '../common/BaseGridContainer';
import { renderStatus } from '../common/broker/utils';
import TablePaginator from '../common/TablePaginator';
import { createQueryRendererProgressV2 } from '../common/QueryRendererProgressV2';


function CSMoneyStatementList(props) {
  const {
    msgRouter,
    viewer,
    filter,
    relay,
  } = props;

  filter.setRelay(relay);
  const [showProcessed, setShowProcessed] = React.useState(false);
  const classes = useCommonStyles();
  const columnDefs = [
    TableFieldMeta.localId,
    TableFieldMeta.priceField('amount', 'Amount', 'amount', 'currency'),
    {
      accessor: node => node,
      Header: 'Processed',
      id: 'status',
      Cell: renderStatus,
      ...TableFieldMeta.centerAlignStyle,
    },
    TableFieldMeta.createdAt,
    TableFieldMeta.field('yourReference', 'Your Ref.'),
    TableFieldMeta.field('internalReference', 'Internal Ref.'),
    TableFieldMeta.field('transactionIndicator', 'Txn. Indicator'),
  ];

  const handleRowSelect = (dataRow, isSelected, newSelectedRowKey) => {
    msgRouter.publishState(this, {
      cashTransactionSelectedRow: isSelected ? dataRow : null,
    });
  };

  const onRowSelectInfo = dataRow => (
    {
      selectEnabled: true,
      rowKey: dataRow.value.id,
      callback: handleRowSelect,
    }
  );

  // React.useEffect(() => {
  //   msgRouter.subscribe(this);
  //   return () => {
  //     msgRouter.unsubscribe(this);
  //   };
  // }, []);

  return (
    <BaseGridContainer>
      <Grid item xs={12}>
        <FormGroup row>
          <TextField
            id="standard-helperText"
            label="Custom Search"
            defaultValue=""
            className={classes.formControl}
            helperText="Description, Amount"
            margin="normal"
            onChange={e => filter.update(e.target.value)}
            style={{ marginRight: '30px' }}
          />
          <FormControlLabel
            control={(
              <Checkbox
                checked={showProcessed}
                color="primary"
                onChange={(e) => {
                  setShowProcessed(e.target.checked);
                  filter.updateVar('processedAt_Isnull', e.target.checked ? null : true);
                }}
              />
            )}
            label="Processed"
          />
        </FormGroup>
      </Grid>
      <Grid item xs={12}>
        <TablePaginator
          filter={filter}
          columns={columnDefs}
          getDataNode={() => (viewer ? viewer.clearstreamMoneyStatements : null)}
          onRowSelectInfo={onRowSelectInfo}
        />
      </Grid>
    </BaseGridContainer>
  );
}

export const query = graphql`
  query CSMoneyStatementListQuery (
    $first: Int,
    $offset: Int,
    $search: String,
    $processedAt_Isnull: Boolean,
  ) {
    viewer {
      ...CSMoneyStatementList_viewer
      @arguments (
        first: $first
        offset: $offset
        search: $search
        processedAt_Isnull: $processedAt_Isnull
      )
    }
  }
`;

const container = createRefetchContainer(
  CSMoneyStatementList,
  {
    viewer: graphql`
      fragment CSMoneyStatementList_viewer on Query
      @argumentDefinitions(
        first: {type: Int, defaultValue: 10 }
        offset: {type: Int, defaultValue: 0 }
        search: {type: String}
        processedAt_Isnull: {type: Boolean, defaultValue: null}
      ) {
        clearstreamMoneyStatements (
          first: $first
          offset: $offset
          orderBy: "-id"
          search: $search
          processedAt_Isnull: $processedAt_Isnull,
        ){
          edges {
            node {
              id
              amount: settledAmount
              createdAt
              updatedAt
              settledAmount
              currency
              processedAt
              processedBy {
                fullName
                id
              }
              brokeractivityPtr {
                id
                brokeractivitytransactionSet {
                  edges {
                    node {
                      id
                      createdAt
                    }
                  }
                }
              }
              
              currency
              transactionIndicator
              yourReference
              internalReference
              isin
              commonCode
              
              notes {
                id
              }
              
            }
          }
          count
        }
      }
    `,
  },
  query,
);

export default withRouter(createQueryRendererProgressV2(
  query,
  container,
  {},
  ({ custodian }) => ({ processedAt_Isnull: true, custodian }),
));
